// A section whose only item is the parent menu (전국현황·지역·아파트·분석) is flattened: the parent
// becomes the subheader and its sub-menus are listed directly. Those sub-menus keep their desktop
// icons in the config, but on mobile only parent-level entries show icons, so they are marked.
export const flattenSections = (sections) =>
  sections.map((section) => {
    if (
      section.subheader &&
      section.items?.length === 1 &&
      section.items[0].items &&
      section.items[0].title === section.subheader
    ) {
      return { ...section, items: section.items[0].items.map((item) => ({ ...item, mobileIconless: true })) };
    }
    return section;
  });
